import { defineClassNames } from '../../../utils/defineClassNames';

export const classes = defineClassNames('side-panel-header', {
  root: {
    variants: {
      skin: ['standard', 'floating'],
    },
    states: ['isDraggable'],
  },
  titleContainer: { states: ['noCloseButton'] },
  title: {},
  floatingTitle: {},
  standardTitle: {},
  subtitle: {},
  buttonBox: {},
  helpIcon: {},
  helpButton: {},
  closeButton: {},
  backButton: {},
  divider: {},
});
